import React from 'react'

const ForgotPassowrd = () => {
  return (
    <div>Contact Admin: +420733295086</div>
  )
}

export default ForgotPassowrd